<form [formGroup]="productionEntryForm" (ngSubmit)="onSubmit()">
  <!-- Company filter -->
  <div class="mb-3">
    <label class="form-label fw-semibold">
      Company
      <span class="text-muted fw-normal small ms-1">(filters product list)</span>
    </label>
    <ng-select
      formControlName="company"
      placeholder="Select company..."
      [items]="companyList"
      bindLabel="name"
      bindValue="id"></ng-select>
  </div>

  <!-- Factory + Production Date -->
  <div class="row g-2 mb-3">
    <div class="col-6">
      <label class="form-label fw-semibold">
        Factory
        <span class="text-danger">*</span>
      </label>
      <ng-select
        formControlName="factory"
        placeholder="Select factory..."
        [items]="factoryList"
        bindLabel="name"
        bindValue="id"></ng-select>
    </div>
    <div class="col-6">
      <label class="form-label fw-semibold">
        Production Date
        <span class="text-danger">*</span>
      </label>
      <input type="date" class="form-control" formControlName="production_date" />
    </div>
  </div>

  <!-- Entries header -->
  <div class="d-flex align-items-center justify-content-between mb-2">
    <span class="extra-small fw-semibold text-uppercase text-muted" style="letter-spacing: 0.05em">
      Products
      @if (entries.length > 1) {
        <span class="badge bg-secondary-subtle text-secondary rounded-pill ms-1">{{ entries.length }}</span>
      }
    </span>
    <button type="button" class="btn btn-soft-primary" (click)="addEntry()">
      <i class="bi bi-plus-lg"></i>
      Add Product
    </button>
  </div>

  <!-- Entry cards -->
  <div formArrayName="entries" class="d-flex flex-column gap-2">
    @for (entry of entries.controls; track $index; let i = $index) {
      <div [formGroupName]="i" class="border rounded p-3 position-relative">
        <!-- Remove button -->
        @if (entries.length > 1) {
          <button
            type="button"
            class="btn btn-sm btn-link text-danger p-0 position-absolute"
            style="top: 10px; right: 10px; line-height: 1"
            (click)="removeEntry(i)">
            <i class="bi bi-x-lg"></i>
          </button>
        }

        @if (entries.length > 1) {
          <div class="extra-small fw-semibold text-muted text-uppercase mb-2" style="letter-spacing: 0.05em">
            Product {{ i + 1 }}
          </div>
        }

        <!-- Product selector -->
        <div class="mb-2">
          <label class="form-label small">
            Product
            <span class="text-danger">*</span>
          </label>
          <ng-select
            formControlName="product"
            placeholder="Search product..."
            [items]="filteredProductList"
            [loading]="isProductListLoading"
            bindLabel="name"
            bindValue="id"></ng-select>
          @if (!productionEntryForm.get('company')?.value) {
            <div class="form-text text-muted">
              <i class="bi bi-info-circle me-1"></i>
              Select a company above to filter this list
            </div>
          }
        </div>

        <!-- Packaging loading state -->
        @if (entryPackagingLoading[i]) {
          <div class="text-muted small mb-2">
            <span class="spinner-border spinner-border-sm me-1"></span>
            Loading packaging options...
          </div>
        }

        <!-- No packaging warning -->
        @if (entry.get('product')?.value && !entryPackagingLoading[i] && entryPackagingLists[i]?.length === 0) {
          <div class="alert alert-info py-2 px-3 small mb-2">
            <i class="bi bi-info-circle me-2"></i>
            No packaging configured for this product. Add packaging options from the Products page.
          </div>
        }

        <!-- Entry fields (shown once packaging is available) -->
        @if (entry.get('product')?.value && !entryPackagingLoading[i] && (entryPackagingLists[i]?.length ?? 0) > 0) {
          <!-- Packaging -->
          <div class="mb-2">
            <label class="form-label small">
              Packaging
              <span class="text-danger">*</span>
            </label>
            <ng-select
              formControlName="product_packaging"
              placeholder="Select packaging..."
              [items]="entryPackagingLists[i]"
              bindLabel="label"
              bindValue="id"></ng-select>
          </div>

          <!-- Box Produced + Batch Number -->
          <div class="row g-2 mb-2">
            <div class="col-6">
              <label class="form-label small">
                Box Produced
                <span class="text-danger">*</span>
              </label>
              <input type="number" class="form-control form-control-sm" formControlName="box_produced" min="1" />
            </div>
            <div class="col-6">
              <label class="form-label small">
                Batch Number
                <span class="text-danger">*</span>
              </label>
              <input type="text" class="form-control form-control-sm" formControlName="batch_number" />
            </div>
          </div>

          <!-- Mfg Date + Expiry Date -->
          <div class="row g-2 mb-2">
            <div class="col-6">
              <label class="form-label small">Mfg. Date</label>
              <input type="date" class="form-control form-control-sm" formControlName="manufacturing_date" />
            </div>
            <div class="col-6">
              <label class="form-label small">Expiry Date</label>
              <input type="date" class="form-control form-control-sm" formControlName="expiry_date" />
            </div>
          </div>

          <!-- Remarks -->
          <div>
            <label class="form-label small">Remarks</label>
            <textarea class="form-control form-control-sm" formControlName="remarks" rows="2"></textarea>
          </div>
        }
      </div>
    }
  </div>

  <!-- Submit -->
  <div class="d-flex justify-content-end mt-3">
    <button
      class="btn btn-primary d-flex align-items-center gap-2"
      [disabled]="productionEntryForm.invalid"
      type="submit">
      <i class="bi bi-check-circle"></i>
      Save
      @if (entries.length > 1) {
        {{ entries.length }} Entries
      }
    </button>
  </div>
</form>
